/* UI compartida (theme Shopify): menú lateral, drawer, cards, carrito NATIVO (Cart AJAX API).
   Header/footer/cinta/marquee ahora son secciones Liquid; aquí solo viven los overlays dinámicos
   (#menuDrawer, #drawer — sus shells están en snippets/drawers.liquid) y el carrito.
   Datos de marca/contacto/asset vienen de window.THEME (puente Liquid→JS en theme.liquid). */
var T = window.THEME || { wa:"https://wa.me/528186916631", routes:{}, assets:{} };
var COLL = (T.routes && T.routes.allProducts) || "/collections/all";

/* ---------- CARRITO NATIVO (Shopify Cart AJAX API) ---------- */
var Cart = {
  _state: { item_count: 0, items: [], total_price: 0 },
  fetch: function(){
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(c){ Cart._state = c; return c; });
  },
  /* add por ID de variante de Shopify (lo trae window.CATALOG y la PDP) */
  add: function(variantId, qty){
    qty = qty || 1;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    }).then(function(r){
      if (!r.ok) return r.json().then(function(e){ throw e; });
      return r.json();
    }).then(function(){ return Cart.fetch(); })
      .then(function(){ UI.renderCartCount(); UI.openDrawer(true); })
      .catch(function(e){ console.error("[cart] add", e); alert((e && e.description) || "No se pudo agregar a la bolsa."); });
  },
  /* change por KEY de línea (string que da /cart.js). qty 0 = quitar. */
  change: function(key, qty){
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); })
      .then(function(c){ Cart._state = c; UI.renderCartCount(); UI.renderDrawer(); if (UI.renderBagPage) UI.renderBagPage(); });
  },
  count: function(){ return Cart._state.item_count || 0; },
  items: function(){ return Cart._state.items || []; },
  subtotal: function(){ return (Cart._state.total_price || 0) / 100; } // Shopify da centavos
};
var money = function(n){ return "$" + Math.round(n).toLocaleString("en-US"); };

/* Config del menú lateral V2·A. chips = [etiqueta, valor real]: categorías → TIPO real (deep-link ?c&tipo=),
   marcas → marca exacta (?marca=). Fotos y rutas vienen de window.THEME. */
var MENU = [
  { key:"tenis", label:"Tenis", href:COLL+"?c=tenis", photo:(T.assets.menuTenis||""),
    chips:[["Low Top","Low Top"],["High Top","High Top"],["Designer","Designer"],["Comfort","Comfort"]] },
  { key:"ropa", label:"Ropa", href:COLL+"?c=ropa", photo:(T.assets.menuRopa||""),
    chips:[["T-shirts","T-shirts"],["Hoodie","Hoodie"],["Jersey","Jersey"],["Jeans","Jeans"]] },
  { key:"accesorios", label:"Accesorios", href:COLL+"?c=accesorios", photo:(T.assets.menuAccesorios||""),
    chips:[["Gorra","Gorra"],["Lentes","Lentes"],["Bolsa","Bolsa"],["Reloj","Reloj"]] },
  { key:"marcas", label:"Marcas", href:"/pages/marcas", photo:(T.assets.menuMarcas||""), brands:true,
    chips:[["Golden Goose","GOLDEN GOOSE"],["Nude Project","NUDE PROJECT"],["Veja","VEJA"],
           ["On Cloud","ON CLOUD"],["Represent","REPRESENT"],["Essentials","ESSENTIALS"]] },
];
var UI = {
  WA: T.wa,
  /* talla para display: solo la parte CM si existe ("27.6 CM / 42 EU" -> "27.6 CM") */
  sizeLabel: function(s){ var m = String(s||"").match(/([\d.]+)\s*CM/i); return m ? m[1]+" CM" : (s||""); },
  product: function(handle){ return (window.CATALOG.products||[]).find(function(p){ return p.handle===handle; }); },
  pdpUrl: function(p){ return "/products/" + p.handle; },
  /* variante representativa para precio: prefiere oferta REAL, si no la primera disponible */
  saleVariant: function(p){
    return p.variants.filter(function(v){ return v.available; }).find(function(v){ return v.compareAt && v.compareAt > v.price; })
        || p.variants.find(function(v){ return v.compareAt && v.compareAt > v.price; })
        || p.variants.find(function(v){ return v.available; })
        || p.variants[0];
  },
  priceHtml: function(v){
    if (!v) return "—";
    return (v.compareAt && v.compareAt > v.price)
      ? money(v.price) + '<span class="tachado">' + money(v.compareAt) + '</span>'
      : money(v.price);
  },
  /* foto de tarjeta: pide al CDN 600 px (la tarjeta mide ≤ 340 px CSS) en vez del original de 2000+ px
     que trae /products.json; respeta un width= previo si la URL ya lo trae (catálogo Liquid) */
  thumb: function(u){
    if (!u) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, "$1width=600");
    return u + (u.indexOf("?") === -1 ? "?" : "&") + "width=600";
  },
  card: function(p){
    var last = p.variants.filter(function(v){ return v.available; }).reduce(function(n,v){ return n+v.qty; },0) === 1;
    var v = this.saleVariant(p);
    var enSale = !!(v && v.compareAt && v.compareAt > v.price);
    return '<a class="card" href="' + this.pdpUrl(p) + '"><div class="card-ph" data-bg="blanco">' +
      (p.images[0] ? '<img loading="lazy" src="'+this.thumb(p.images[0])+'" alt="">' : '<span class="ph-tag">FOTO PENDIENTE</span>') +
      (last ? '<span class="badge-ultima">ÚLTIMA PIEZA</span>' : (enSale ? '<span class="card-sale">SALE</span>' : '')) +
      '</div><p class="card-marca">'+p.brand+'</p><h3 class="card-title">'+p.title+'</h3>' +
      '<p class="card-precio">'+this.priceHtml(v)+'</p></a>';
  },
  saleCard: function(p){
    var v = this.saleVariant(p);
    return '<a class="card" href="' + this.pdpUrl(p) + '"><div class="card-ph" data-bg="blanco">' +
      (p.images[0] ? '<img loading="lazy" src="'+this.thumb(p.images[0])+'" alt="">' : '<span class="ph-tag">FOTO PENDIENTE</span>') +
      '<span class="card-sale">SALE</span></div>' +
      '<p class="card-marca">'+p.brand+'</p><h3 class="card-title">'+p.title+'</h3>' +
      '<p class="card-precio">'+this.priceHtml(v)+'</p></a>';
  },
  /* filas del home como carrusel (port del MVP final): páginas de 2 (móvil) /
     4 (desktop) que llenan el riel y se swipean/avanzan enteras */
  enPaginas: function(items, render){
    var per = window.matchMedia("(min-width:900px)").matches ? 4 : 2, h = "";
    for (var i = 0; i < items.length; i += per)
      h += '<div class="row-page">' + items.slice(i, i + per).map(render).join("") + '</div>';
    return h;
  },
  /* flecha del carrusel — móvil: nudge que se desvanece al primer swipe;
     desktop: botón persistente que avanza una página y se oculta al final */
  initRowCarousel: function(car){
    if (!car || car.dataset._rcDone) return;
    car.dataset._rcDone = "1";
    var pages = car.querySelector(".row-pages");
    var arrow = car.querySelector(".row-arrow");
    if (!pages || !arrow) return;
    if (window.matchMedia("(min-width:900px)").matches){
      var alFinal = function(){ return pages.scrollLeft + pages.clientWidth >= pages.scrollWidth - 8; };
      if (alFinal()){ car.classList.add("swiped"); return; } /* una sola página: sin flecha */
      arrow.removeAttribute("aria-hidden");
      arrow.setAttribute("role", "button");
      arrow.setAttribute("aria-label", "Ver más productos");
      arrow.setAttribute("tabindex", "0");
      var avanza = function(){ pages.scrollBy({ left: pages.clientWidth, behavior: "smooth" }); };
      arrow.addEventListener("click", avanza);
      arrow.addEventListener("keydown", function(e){ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); avanza(); } });
      pages.addEventListener("scroll", function(){ car.classList.toggle("swiped", alFinal()); }, { passive:true });
    } else {
      pages.addEventListener("scroll", function(){ car.classList.add("swiped"); }, { once:true, passive:true });
    }
  },
  mount: function(){
    this.renderMenu();
    Cart.fetch().then(function(){ UI.renderCartCount(); UI.renderDrawer(); });
  },
  /* ---------- menú lateral V2·A (drawer izquierdo) ---------- */
  menuOpenKey: "tenis",
  svgX: function(s){ return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 18 18" fill="none" aria-hidden="true"><line x1="3.5" y1="3.5" x2="14.5" y2="14.5" stroke="currentColor" stroke-width="1.6"/><line x1="14.5" y1="3.5" x2="3.5" y2="14.5" stroke="currentColor" stroke-width="1.6"/></svg>'; },
  svgSearchC: function(s){ return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 18 18" fill="none" aria-hidden="true"><circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.7"/><line x1="12.2" y1="12.2" x2="17" y2="17" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>'; },
  svgArrow: function(s){ return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 16 16" fill="none" aria-hidden="true"><line x1="2" y1="8" x2="12.4" y2="8" stroke="currentColor" stroke-width="1.5"/><polyline points="8,3.6 12.8,8 8,12.4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'; },
  svgPlus: function(s){ return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 16 16" fill="none" aria-hidden="true"><line x1="8" y1="2.6" x2="8" y2="13.4" stroke="currentColor" stroke-width="1.6"/><line x1="2.6" y1="8" x2="13.4" y2="8" stroke="currentColor" stroke-width="1.6"/></svg>'; },
  svgMinus: function(s){ return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 16 16" fill="none" aria-hidden="true"><line x1="2.6" y1="8" x2="13.4" y2="8" stroke="currentColor" stroke-width="1.6"/></svg>'; },
  menuMarkup: function(){
    var self = this;
    var head = '<div class="mn-head">' +
      '<button class="mn-x" aria-label="Cerrar" onclick="UI.closeMenu()">' + self.svgX(18) + '</button>' +
      '<span class="mn-head-cap">Menú</span>' +
      '<button class="mn-x" aria-label="Buscar" data-track="buscador-abrir" onclick="UI.searchFromMenu()">' + self.svgSearchC(17) + '</button>' +
      '</div>';
    var items = MENU.map(function(cat){
      var open = self.menuOpenKey === cat.key;
      var chips = cat.chips.map(function(ch){
        var href = cat.brands
          ? COLL + "?marca=" + encodeURIComponent(ch[1]).replace(/%20/g, "+")
          : COLL + "?c=" + cat.key + "&tipo=" + encodeURIComponent(ch[1]).replace(/%20/g, "+");
        return '<a href="' + href + '" class="mn-chip">' + ch[0] + '</a>';
      }).join("");
      return '<div class="mn-acc-item mn-acc-item--photo' + (open ? " is-open" : "") + '" data-acc="' + cat.key + '">' +
        '<button class="mn-acc-head" onclick="UI.menuAcc(\'' + cat.key + '\')"><span>' + cat.label + '</span>' +
          '<span class="mn-acc-ico"><span class="mn-ico-plus">' + self.svgPlus(15) + '</span><span class="mn-ico-minus">' + self.svgMinus(15) + '</span></span></button>' +
        '<div class="mn-acc-panel"><div class="mn-acc-inner">' +
          '<a href="' + cat.href + '" class="mn-acc-photo"><img loading="lazy" src="' + cat.photo + '" alt="' + cat.label + '">' +
            '<span class="mn-acc-photo-cap">Ver ' + cat.label.toLowerCase() + ' ' + self.svgArrow(12) + '</span></a>' +
          '<div class="mn-acc-chips">' + chips + '</div>' +
        '</div></div></div>';
    }).join("");
    var body = '<div class="mn-body mn-body--scroll"><div class="mn-acc">' + items + '</div>' +
      '<a href="' + COLL + '?c=todas&sale=1" class="mn-acc-solo mn-acc-solo--last">Sale</a></div>';
    var tail = '<div class="mn-tail mn-tail--bar">' +
      '<div class="mn-tail-cols">' +
        '<a href="/pages/la-tienda" class="mn-tail-link">La tienda</a>' +
        '<a href="/pages/garantia" class="mn-tail-link">Garantía</a>' +
        '<a href="' + self.WA + '" target="_blank" rel="noopener" class="mn-tail-link" data-track="menu-whatsapp">Contacto</a>' +
      '</div>' +
      '</div>';
    return head + body + tail;
  },
  renderMenu: function(){ var el = document.getElementById("menuDrawer"); if(el) el.innerHTML = this.menuMarkup(); },
  menuAcc: function(key){
    var drawer = document.getElementById("menuDrawer");
    var target = drawer.querySelector('.mn-acc-item[data-acc="' + key + '"]');
    var wasOpen = target.classList.contains("is-open");
    drawer.querySelectorAll(".mn-acc-item").forEach(function(it){ it.classList.remove("is-open"); });
    if(!wasOpen) target.classList.add("is-open");
    this.menuOpenKey = wasOpen ? "" : key;
  },
  openMenu: function(){
    this.menuOpenKey = "tenis"; this.renderMenu();
    document.getElementById("menuDrawer").classList.add("open");
    document.getElementById("menuVeil").classList.add("open");
    document.getElementById("menuDrawer").setAttribute("aria-hidden", "false");
    var b = document.getElementById("hdrBurger"); if(b) b.setAttribute("aria-expanded", "true");
  },
  closeMenu: function(){
    document.getElementById("menuDrawer").classList.remove("open");
    document.getElementById("menuVeil").classList.remove("open");
    document.getElementById("menuDrawer").setAttribute("aria-hidden", "true");
    var b = document.getElementById("hdrBurger"); if(b) b.setAttribute("aria-expanded", "false");
  },
  searchFromMenu: function(){ this.closeMenu(); this.openSearch(); },
  renderCartCount: function(){ var el=document.getElementById("cartCount"); if(el) el.textContent = Cart.count(); },
  openDrawer: function(justAdded){
    this.renderDrawer(justAdded);
    document.getElementById("drawer").classList.add("open");
    document.getElementById("drawerVeil").classList.add("open");
  },
  closeDrawer: function(){
    document.getElementById("drawer").classList.remove("open");
    document.getElementById("drawerVeil").classList.remove("open");
  },
  /* ítem de bolsa compartido drawer/página. i = línea de /cart.js (trae key, variant_id, quantity,
     product_title, vendor, variant_title, price, image, handle). */
  bagItem: function(i, page){
    var brand = i.vendor || "";
    var size = UI.sizeLabel(i.variant_title || "Unitalla");
    var k = JSON.stringify(i.key); // seguro dentro de onclick (comillas dobles del atributo no chocan: el atributo usa comillas dobles, ver nota)
    return '<div class="bag-item'+(page?' bag-item--page':'')+'">' +
      '<a class="bag-thumb" href="/products/'+i.handle+'" aria-label="'+(i.product_title||"")+'">' +
        (i.image ? '<img loading="lazy" src="'+i.image+'" alt="">' : '<span class="ph-tag">FOTO PENDIENTE</span>') + '</a>' +
      '<div class="bag-info"><p class="card-marca">'+brand+'</p>' +
        '<p class="bag-name">'+(i.product_title||"")+'</p>' +
        '<p class="bag-talla">Talla — '+size+'</p>' +
        '<p class="bag-precio">'+money((i.price||0)/100)+'</p>' +
        '<div class="bag-controls"><div class="bag-qty">' +
          "<button aria-label='Menos' onclick='Cart.change("+k+","+(i.quantity-1)+")'>−</button>" +
          '<span class="bag-qty-n">'+i.quantity+'</span>' +
          "<button aria-label='Más' onclick='Cart.change("+k+","+(i.quantity+1)+")'>+</button></div>" +
        "<button class='bag-remove' onclick='Cart.change("+k+",0)'>Quitar</button>" +
      '</div></div></div>';
  },
  renderDrawer: function(justAdded){
    var drawer = document.getElementById("drawer"); if(!drawer) return;
    var items = Cart.items();
    var rows = items.map(function(i){ return UI.bagItem(i); }).join("");
    drawer.innerHTML =
      (justAdded ? '<div class="dr-confirm">AGREGADO</div>' : '') +
      '<div class="dr-head"><span>TU BOLSA — '+Cart.count()+'</span><button aria-label="Cerrar" onclick="UI.closeDrawer()">✕</button></div>' +
      (items.length ? '<div class="dr-items">'+rows+'</div>' +
        '<div class="dr-foot">' +
        '<div class="bag-row"><span class="bag-row-label">SUBTOTAL</span><span class="bag-subtotal">'+money(Cart.subtotal())+'</span></div>' +
        '<p class="dr-trust">Envío gratis · ' + THEME.envio.min + '-' + THEME.envio.max + ' días hábiles · garantía de autenticidad</p>' +
        '<button class="btn btn-ink" data-track="checkout-handoff" onclick="UI.checkout()">COMPLETAR MI PEDIDO</button>' +
        '<div class="bag-links"><a class="bag-link" href="'+(T.routes.cart||"/cart")+'">Ver bolsa completa</a><span class="bag-links-sep">·</span>' +
        '<button class="bag-link bag-link--quiet" onclick="UI.closeDrawer()">Seguir comprando</button></div></div>'
      : '<p class="dr-empty">Tu bolsa está vacía.</p>' +
        '<div class="bag-links"><button class="bag-link bag-link--quiet" onclick="UI.closeDrawer()">Seguir comprando</button></div>');
  },
  checkout: function(){
    /* medición: begin_checkout — la MÉTRICA EJE (sesión→checkout de alta intención) */
    try { if (window.Track) { var c = Cart._state || {}; Track.emit("begin_checkout", { value: (c.total_price||0)/100, currency: "MXN", num_items: c.item_count || 0 }); } } catch(e){}
    window.location.href = "/checkout";
  },
  openSearch: function(){ if(typeof window._openBuscador === 'function') window._openBuscador(); }
};
document.addEventListener("DOMContentLoaded", function(){ UI.mount(); });
document.addEventListener("keydown", function(e){ if(e.key === "Escape"){ UI.closeDrawer(); UI.closeMenu(); } });
